import ErrorStackParser from 'error-stack-parser'
import { SourceMapConsumer } from 'source-map'

export async function translateStackTrace(error: Error): Promise<string> {
  const parsedFrames = ErrorStackParser.parse(error)
  const output: string[] = []

  for (const frame of parsedFrames) {
    const fileUrl = frame.fileName
    if (!fileUrl || !fileUrl.includes('/assets/') || !fileUrl.endsWith('.js')) {
      output.push(`${frame.functionName} at ${fileUrl}:${frame.lineNumber}:${frame.columnNumber}`)
      continue
    }

    const fileName = fileUrl.split('/').pop()
    const mapUrl = `/assets/${fileName}.map`

    try {
      const response = await fetch(mapUrl)
      if (!response.ok) {
        output.push(`${frame.functionName} at ${fileUrl}:${frame.lineNumber}:${frame.columnNumber} (source map não encontrado)`)
        continue
      }

      const rawSourceMap = await response.json()
      const consumer = await new SourceMapConsumer(rawSourceMap)

      const original = consumer.originalPositionFor({
        line: frame.lineNumber!,
        column: frame.columnNumber!,
      })

      consumer.destroy()

      output.push(
        `${frame.functionName || '(anonymous)'} at ${original.source}:${original.line}:${original.column}`,
      )
    } catch (e) {
      output.push(`${frame.functionName} at ${fileUrl}:${frame.lineNumber}:${frame.columnNumber} (falha ao traduzir)`)
    }
  }

  return output.join('\n')
}
